import React, { useMemo} from 'react';
import styles from './PreparationsWithAlternative.module.scss';
import { Collapse } from 'antd';
import Tooltip from 'antd/es/tooltip';
import { UpOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Content, Lesson } from '@types';
import { LessonType, LastVisitedLessonContentFragment } from '@api/graphql-codegen';
import SectionContents from '@src/components/program-details/lesson/lesson-section/section-contents/SectionContents';

const { Panel } = Collapse;

const PanelTitle = ({ title, isSection }: { title: string; isSection?: boolean }) => {
  return (
    <div>
      <div className={styles.panelTitle}>{title}</div>
      <div className={styles.panelSubTitle}>{isSection ? '(5 - 10 mins each)' : '(30 mins +)'}</div>
    </div>
  );
};

const ExtraInfoIcon = ({ tooltipTitle }: { tooltipTitle: string }) => {
  return (
    <div className={styles.extraInfoIconContainer}>
      <Tooltip
        placement='top'
        title={<div className={styles.extraInfoIconTooltip}>
          {tooltipTitle}
        </div>}
        arrowPointAtCenter
        color='#FFFFFF'>
        <InfoCircleOutlined className={styles.extraInfoIcon} />
      </Tooltip>
    </div>
  )
};


type Props = {
  contents: Content[] | undefined;
  alternativeContents: Content[] | undefined;
  lesson: Lesson | undefined;
  lessonType: LessonType | undefined;
  lessonOpened: boolean;
  lastVisitedLesson?: LastVisitedLessonContentFragment;
  closeNav?: () => void;
};

function Preparations(props: Props) {
  const { contents = [], lesson, lessonOpened, lastVisitedLesson, closeNav, alternativeContents } = props;

  const wrapperClassName = useMemo(() => {
    const classes = [styles.wrapper];
    if (lessonOpened) {
      classes.push(styles.opened);
    }

    return classes.join(' ');
  }, [lessonOpened]);
  
  return (
    <div className={wrapperClassName}>
      <div className={styles.content}>
        <Collapse
          bordered={false}
          defaultActiveKey={['1', '2']}
          expandIconPosition="end"
          expandIcon={({ isActive }) => <UpOutlined style={{ fill: '#FFF', color: '#FFF', strokeWidth: '3px', width: 20, fontSize: '20px' }} rotate={isActive ? 180 : 0} />}
          style={{ backgroundColor: 'transparent' }}
        >
          <Panel header={<PanelTitle title="One Longer Class" />} key="1" className={styles.panelStyle} extra={<ExtraInfoIcon tooltipTitle='Select this option if you have 30 minutes or longer for the Lesson.' />} >
            <div className={styles.contentsContainer}>
              <SectionContents contents={contents} lesson={lesson} lastVisitedLesson={lastVisitedLesson} isPreparation closeNav={closeNav}/>
            </div>
          </Panel>
          <Panel header={<PanelTitle title="Multiple Short Classes" isSection />} key="2" className={styles.panelStyle} extra={<ExtraInfoIcon tooltipTitle='Select this option if you have less than 20 minutes for the Lesson.' />} >
            <div className={`${styles.contentsContainer} ${styles.introContentContainer}`}>
              <SectionContents contents={alternativeContents || []} lesson={lesson} lastVisitedLesson={lastVisitedLesson} isPreparation closeNav={closeNav} />
            </div>
          </Panel>
        </Collapse>
      </div>
    </div>
  );
}

export default React.memo(Preparations);
